import React from 'react';
import { withRouter } from 'react-router';
import utils from '../../modules/utils';

const Footer = props => {
  const { location } = props;
  let footer;

  if (
    utils.getState().prodotto == 3
    || utils.getState().found_db_compass
    || (utils.getState().flowSwitch && utils.getState().flowSwitch.previousFlow==3)
  ) {
    /* NOTA LEGALE C5 (da aggiornare con la scadenza delle soglie usura) */
    footer = (
      <footer
        className={`footer${location.pathname.includes('thank-you') ||
          location.pathname.includes('modifica-appuntamento')
          ? ' footer-gray'
          : ' footer-gray'
          }`}
      >
        <div className='divider'></div>
        <h4>INFORMAZIONI TRASPARENTI</h4>
        <p>
          Messaggio pubblicitario con finalità promozionale. Per le condizioni
          economiche e contrattuali si rimanda ai documenti informativi
          disponibili presso le filiali Compass Banca S.p.A. e/o presso gli agenti in attività
          finanziaria di Compass Banca S.p.A. (Agenzie Autorizzate CompassQuinto) che operano in 
          qualità di intermediari del credito
          con mandato in esclusiva di prodotto Compass Banca S.p.A.. L'elenco delle Filiali
          e delle Agenzie Autorizzate CompassQuinto è disponibile, rispettivamente, sul sito&nbsp;
          <a href="https://www.compass.it" target="_blank">
            www.compass.it
          </a>
          &nbsp;e sul sito&nbsp;
          <a href="https://www.compassquinto.it" target="_blank">
            www.compassquinto.it
          </a>
          .
          Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione
          del quinto dello stipendio richiesto da un dipendente pubblico di {window.USR_FA_C5_ETA_DIPENDENTE_PUBBLICO} anni.
          Importo totale del credito {window.USR_FA_C5_IMPORTO_TOTALE_CREDITO} €. Importo totale dovuto {window.USR_FA_C5_IMPORTO_TOTALE_DOVUTO} €. Durata
          del contratto: {window.USR_FA_C5_DURATA_CONTRATTO} mesi. Importo rata {window.USR_FA_C5_IMPORTO_RATA} €. TAEG {window.USR_FA_C5_TAEG}% inclusivo di:
          interessi al Tan Fisso {window.USR_FA_C5_TAN} % e bollo {window.USR_FA_C5_BOLLO} €. Offerta valida fino al {window.USR_GEN_VALIDITA}.
          Prestito rimborsabile in minimo {window.USR_FA_C5_RIMBORSABILE_MINIMO} rate e massimo {window.USR_FA_C5_RIMBORSABILE_MASSIMO} rate. TAEG
          massimo applicabile per il trimestre di riferimento, fino al {window.USR_GEN_VALIDITA}:
          {window.USR_FA_C5_TAEG_MASSIMO}%. Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A.. CompassQuinto è un marchio di Compass Banca S.p.A., socio unico
          direzione e coordinamento Mediobanca S.p.A. N. Partita IVA Gruppo IVA
          Mediobanca: 10536040966, C.F e n. iscr. R.I. di Milano 00864530159. Tutti i
          diritti riservati, Via Caldera, 21 – 20153 Milano.&nbsp;
          <a
            href="https://www.compass.it/dati-societari-compass-spa.html"
            target="_blank"
          >
            Dati Societari
          </a>
          <br />
          <br />
          Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;
          <a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e
          i&nbsp;
          <a href="https://policies.google.com/terms">Termini di servizio</a>&nbsp;di
          Google.
        </p>
      </footer>
    );
  }/* else if (utils.getState().found_db_compass) { //Sei stato trovato nelle liste compass
    footer = (
      <footer className='footer'>
        <div className='divider'></div>
        <h4>INFORMAZIONI TRASPARENTI</h4>
        <p>
          Compass Banca S.p.A. - Sede Legale e Direzione Generale: Via Caldera, 21 - 20153 Milano, socio unico direzione e coordinamento Mediobanca S.p.A.,
          Partita IVA Gruppo IVA Mediobanca: 10536040966; C.F N. iscr. R.I. di Milano 00864530159.
          Tutti i diritti riservati - <a href='https://www.compass.it/dati-societari-compass-spa.html'>Dati societari</a> - Offerta promozionale valida fino al {window.USR_GEN_VALIDITA}.
          Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del quinto dello
          stipendio erogato da Compass Banca S.p.A. e richiesto da un dipendente pubblico di {window.USR_FA_CMP_ETA_DIPENDENTE_PUBBLICO} anni.
          Importo totale del credito {window.USR_FA_CMP_IMPORTO_TOTALE_CREDITO} €. Importo totale dovuto {window.USR_FA_CMP_IMPORTO_TOTALE_DOVUTO} €. Durata del contratto: {window.USR_FA_CMP_DURATA_CONTRATTO} mesi.
          Importo rata {window.USR_FA_CMP_IMPORTO_RATA} €. TAEG {window.USR_FA_CMP_TAEG}% inclusivo di: interessi al Tan Fisso {window.USR_FA_CMP_TAN}%; spese fisse contrattuali e bollo {window.USR_FA_CMP_BOLLO} €.
          Offerta promozionale valida fino al {window.USR_GEN_VALIDITA}. Ogni finanziamento necessita delle coperture assicurative, di cui Compass Banca S.p.A.
          sarà contraente e beneficiaria, dovute per legge ai sensi del DPR n. 180/50. Prestito rimborsabile in minimo {window.USR_FA_CMP_RIMBORSABILE_MINIMO} rate e massimo {window.USR_FA_CMP_RIMBORSABILE_MASSIMO} rate.
          TAEG massimo applicabile per il trimestre di riferimento, fino al {window.USR_GEN_VALIDITA}: {window.USR_FA_CMP_TAEG_MASSIMO}%.
          </p>
      </footer>
    );
  }*/ else {
    if (
      location.pathname === utils.getFaPath() + '/thank-you-page-CQ' //||
      // location.pathname === utils.getFaPath() + '/thank-you-page-AUP' ||
      //location.pathname === utils.getFaPath() + '/thank-you-page' ||
      //location.pathname === utils.getFaPath() + '/conferma-modifica-appuntamento' ||
      //location.pathname === utils.getFaPath() + '/riepilogo-modifica-appuntamento'
    ) {
      /* NOTA LEGALE C5 (da aggiornare con la scadenza delle soglie usura) */
      footer = (
        <footer className='footer'>
          <div className='divider'></div>
          <h4>INFORMAZIONI TRASPARENTI</h4>
          <p>
            Messaggio pubblicitario con finalità promozionale. Per le condizioni
            economiche e contrattuali si rimanda ai documenti o ai fogli informativi
            disponibili sul sito&nbsp;
            <a href="https://www.compass.it" target="_blank">
              www.compass.it
            </a>
            &nbsp;e&nbsp;
            <a href="https://www.compassquinto.it" target="_blank">
              www.compassquinto.it
            </a>
            &nbsp;e presso le Filiali Compass Banca S.p.A. o gli Agenti in attività
            finanziaria autorizzati che operano in qualità di intermediari del credito
            convenzionati in esclusiva con Compass Banca S.p.A.. L'elenco delle Filiali
            Compass Banca S.p.A. e delle Agenzie autorizzate è disponibile sul sito&nbsp;
            <a href="https://www.compass.it" target="_blank">
              www.compass.it
            </a>
            &nbsp;e&nbsp;
            <a href="https://www.compassquinto.it" target="_blank">
              www.compassquinto.it
            </a>
            . Salvo approvazione di Compass Banca S.p.A. alla richiesta di finanziamento.
            Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione
            del quinto dello stipendio richiesto da un dipendente pubblico di {window.USR_FA_C5_ETA_DIPENDENTE_PUBBLICO} anni.
            Importo totale del credito {window.USR_FA_C5_IMPORTO_TOTALE_CREDITO} €. Importo totale dovuto {window.USR_FA_C5_IMPORTO_TOTALE_DOVUTO} €. Durata
            del contratto: {window.USR_FA_C5_DURATA_CONTRATTO} mesi. Importo rata {window.USR_FA_C5_IMPORTO_RATA} €. TAEG {window.USR_FA_C5_TAEG}% inclusivo di:
            interessi al Tan Fisso {window.USR_FA_C5_TAN} % e bollo {window.USR_FA_C5_BOLLO} €. Offerta valida fino al {window.USR_GEN_VALIDITA}.
            Ogni finanziamento prevede delle coperture assicurative, di cui Compass Banca
            S.p.A. sarà contraente e beneficiaria, dovute per legge ai sensi del DPR n.
            180/50. Prestito rimborsabile in minimo {window.USR_FA_C5_RIMBORSABILE_MINIMO} rate e massimo {window.USR_FA_C5_RIMBORSABILE_MASSIMO} rate. TAEG
            massimo applicabile per il trimestre di riferimento, fino al {window.USR_GEN_VALIDITA}:
            {window.USR_FA_C5_TAEG_MASSIMO}%. Compass Quinto è un marchio di Compass Banca S.p.A., socio unico
            direzione e coordinamento Mediobanca S.p.A., - N. Partita IVA Gruppo IVA
            Mediobanca: 10536040966., C.F e n. iscr. R.I. di Milano 00864530159. Tutti i
            diritti riservati. : 20153 Milano - Via Caldera, 21.&nbsp;
            <a
              href="https://www.compass.it/dati-societari-compass-spa.html"
              target="_blank"
            >
              Dati societari
            </a>
            <br />
            <br />
            Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;
            <a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e
            i&nbsp;
            <a href="https://policies.google.com/terms">Termini di servizio</a>&nbsp;di
            Google.
          </p>
        </footer>
      );
    } else if (utils.getState().prodotto == 5) {
      /* NOTA LEGALE FAUP (da aggiornare con la scadenza delle soglie usura) */
      footer = (
        <footer className='footer footer-gray'>
          <div className='divider'></div>
          <h4>INFORMAZIONI TRASPARENTI</h4>
          <p>
            Compass Banca S.p.A. - Sede Legale e Direzione Generale: Via
            Caldera, 21 - 20153 Milano, socio unico direzione e coordinamento
            Mediobanca S.p.A., Partita IVA Gruppo IVA Mediobanca: 10536040966;
            C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati -{' '}
            <a
              href='//compass.it/dati-societari-compass-spa.html'
              target='_blank'
            >
              Dati Societari
            </a>{' '}
            - Offerta promozionale valida fino al {window.USR_GEN_VALIDITA}. Esempio
            rappresentativo: Importo totale del credito € {window.USR_FA_BS_IMPORTO_TOTALE_CREDITO}. Importo totale
            dovuto € {window.USR_FA_BS_IMPORTO_TOTALE_DOVUTO}. Modalità di rimborso con addebito diretto in
            conto (SDD). TAEG {window.USR_FA_BS_TAEG}% inclusivo di: interessi al TAN Fisso
            {window.USR_FA_BS_TAN}%; spese di istruttoria pari a € {window.USR_FA_BS_ISTRUTTORIA}; spese incasso e
            gestione pratica € {window.USR_FA_BS_GESTIONE_PRATICA} a rata; oneri fiscali applicati al contratto
            richiesti con 1° rata € {window.USR_FA_BS_ONERI_FISCALI}; oneri fiscali applicati alle
            comunicazioni periodiche di trasparenza € {window.USR_FA_BS_COMUNICAZIONI_TRASPARENZA_PERIODICHE}; spese di invio
            comunicazione periodica di trasparenza annuale € {window.USR_FA_BS_COMUNICAZIONI_TRASPARENZA_ANNUALI} se cartacea
            (gratuita online). Durata totale del finanziamento: {window.USR_FA_BS_DURATA_TOTALE_FINANZIAMENTO} mesi. Salvo
            approvazione di Compass Banca S.p.A. Documenti informativi presso le
            Filiali Compass Banca S.p.A. L'elenco delle Filiali è disponibile sul sito{' '}
            <a href='https://www.compass.it' target="_blank">www.compass.it</a>. Importo
            richiedibile min. {window.USR_FA_BS_MINIMO_RICHIEDIBILE}€ max {window.USR_FA_BS_MASSIMO_RICHIEDIBILE}€ rimborsabile min {window.USR_FA_BS_RIMBORSABILE_MINIMO} mesi, max
            {window.USR_FA_BS_RIMBORSABILE_MASSIMO} mesi. % tassi massimi applicati TAN {window.USR_FA_BS_TAN_MASSIMO}% TAEG {window.USR_FA_BS_TAEG_MASSIMO}%.
            <br />
            Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;<a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e i <a href="https://policies.google.com/terms">Termini di servizio</a> di Google.
          </p>
        </footer>
      );
    } else {
      /* NOTA LEGALE COMPASS (da aggiornare con la scadenza delle soglie usura) */
      var sezione = '';

      if (utils.getState().prodotto == 1) {
        sezione = 'Prestito Personale';
      } else if (utils.getState().prodotto == 4) {
        sezione = 'Carta di credito';
      }

      footer = (
        <footer className='footer footer-gray'>
          <div className='divider'></div>
          <h4>INFORMAZIONI TRASPARENTI</h4>
          <p>
            Compass Banca S.p.A. - Sede Legale e Direzione Generale: Via
            Caldera, 21 - 20153 Milano, socio unico direzione e coordinamento
            Mediobanca S.p.A., Partita IVA Gruppo IVA Mediobanca: 10536040966;
            C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati -{' '}
            <a
              href='//compass.it/dati-societari-compass-spa.html'
              target='_blank'
            >
              Dati Societari
            </a>{' '}
            - Offerta promozionale valida fino al {window.USR_GEN_VALIDITA}. Esempio
              rappresentativo {sezione}: Importo totale del credito € {window.USR_FA_PP_IMPORTO_TOTALE_CREDITO}. Importo totale dovuto € {window.USR_FA_PP_IMPORTO_TOTALE_DOVUTO}. Modalità di
              rimborso con addebito diretto in conto (SDD). TAEG {window.USR_FA_PP_TAEG}% inclusivo di: interessi al TAN Fisso {window.USR_FA_PP_TAN}%; spese di
              istruttoria pari a € {window.USR_FA_PP_ISTRUTTORIA}; spese incasso e gestione pratica € {window.USR_FA_PP_GESTIONE_PRATICA} a rata; oneri fiscali applicati al contratto richiesti con prima
              rata € {window.USR_FA_PP_ONERI_FISCALI}; oneri fiscali applicati alle comunicazioni periodiche di trasparenza € {window.USR_FA_PP_COMUNICAZIONI_TRASPARENZA_PERIODICHE}; spese di invio comunicazione
              periodica di trasparenza annuale € {window.USR_FA_PP_COMUNICAZIONI_TRASPARENZA_ANNUALI} se cartacea (gratuita online). Durata totale del finanziamento: {window.USR_FA_PP_DURATA_TOTALE_FINANZIAMENTO} mesi. Salvo
              approvazione di Compass Banca S.p.A. Documenti informativi presso le Filiali Compass Banca S.p.A o presso gli Agenti
              in attività finanziaria autorizzati che operano in qualità di intermediari del credito convenzionati in esclusiva con Compass
              Banca S.p.A. L'elenco delle Filiali e delle Agenzie autorizzate è disponibile sul sito{' '}
              <a href='https://www.compass.it' target="_blank">www.compass.it</a>. Importo richiedibile
              min. {window.USR_FA_PP_MINIMO_RICHIEDIBILE}€ max {window.USR_FA_PP_MASSIMO_RICHIEDIBILE}€ rimborsabile min {window.USR_FA_PP_RIMBORSABILE_MINIMO} mesi, max {window.USR_FA_PP_RIMBORSABILE_MASSIMO} mesi. % tassi massimi applicati TAN {window.USR_FA_PP_TAN_MASSIMO}% TAEG {window.USR_FA_PP_TAEG_MASSIMO}%.
            <br />
            Questo sito è protetto da reCAPTCHA e si applicano la&nbsp;<a href="https://policies.google.com/privacy">Privacy Policy</a>&nbsp;e i <a href="https://policies.google.com/terms">Termini di servizio</a> di Google.<br />
            Condizioni suscettibili di variazione in caso di richiesta presentata in filiale TAN min {window.USR_FA_PP_TAN_MINIMO_FIL}% TAN max {window.USR_FA_PP_TAN_MASSIMO_FIL}% TAEG min {window.USR_FA_PP_TAEG_MINIMO_FIL}% TAEG max {window.USR_FA_PP_TAEG_MASSIMO_FIL}%.
          </p>
        </footer>
      );
    }
  }

  return footer;
};

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/footer.js